import React, { FC } from 'react';
import { faComments } from '@fortawesome/free-solid-svg-icons/faComments';
import { faMicrophone } from '@fortawesome/free-solid-svg-icons/faMicrophone';
import { faUtensils } from '@fortawesome/free-solid-svg-icons/faUtensils';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import FadeInContainer from '@buyside/components/presentation/FadeInContainer/fadeInContainer';

import styles from './eventFormatStyles.scss';

const blocks = [
  {
    icon: faUtensils,
    title: 'Dinner & Curated Investor Networking',
    body:
      'The evening will begin with dinner, drinks, and informal conversation among a carefully selected group of public market investors. Attendance will be intentionally limited to keep the room focused, relevant, and highly interactive.'
  },
  {
    icon: faMicrophone,
    title: 'Live Expert Call',
    body:
      "We'll host a closed-door conversation with a leading industry voice on the evolving Artificial Intelligence landscape, market structure, and the investment implications for buyside investors. The discussion will include an interactive Q&A and is intended to surface perspectives that go beyond standard conference commentary."
  },
  {
    icon: faComments,
    title: 'The Idea Exchange',
    body:
      'Attendees will have the opportunity to share a brief investment thesis. The goal is not presentation polish - it is thoughtful debate. Bring a long, short, or contrarian angle you are actively underwriting and pressure-test it with other sophisticated investors.'
  }
];

const EventFormat: FC = () => (
  <div id="format" className={styles.formatContainer}>
    <div className={styles.sectionEyebrow}>The Format</div>
    <hr className={styles.sectionDivider} />
    <div className={styles.formatBlocks}>
      {blocks.map(block => (
        <FadeInContainer className={styles.formatBlock} key={block.title}>
          <div className={styles.formatBlockIcon}>
            <FontAwesomeIcon icon={block.icon} />
          </div>
          <div className={styles.formatBlockTitle}>{block.title}</div>
          <div className={styles.formatBlockBody}>{block.body}</div>
        </FadeInContainer>
      ))}
    </div>
  </div>
);

export default EventFormat;
